import React from 'react'
import { MdCheck } from 'react-icons/md'
import { FiEdit } from 'react-icons/fi'
import { useBookletCoupons } from '../../context/BookletCouponsContext'
import PriceContainer from './PriceContainer'
import PrintFooter from './PrintFooter'
import ArrowDown from '../../img/arrow-down.svg'
import CouponItems from './CouponItems'

const { REACT_APP_IMAGE_BASE_URL } = process.env;

interface PrintPageProps {
  pageIndex: number;
  couponsPerPage: number;
  bookletColor: string;
  openCouponSelection: () => void;
  openLogoManager: () => void;
}

const PrintPage: React.FC<PrintPageProps> = ({
  pageIndex,
  couponsPerPage,
  bookletColor,
  openCouponSelection,
  openLogoManager,
}) => {
  const {
    selectedCoupons,
    setSelectedCoupons,
    setSelectedCouponIndex,
    selectedBooklet,
    visibleCompanies,
    companyCategories,
  } = useBookletCoupons();

  const handlePlaceholderClick = (index: number) => {
    setSelectedCouponIndex(index);
    openCouponSelection();
  };

  const handleCouponRemove = (index: number) => {
    const newSelectedCoupons = [...selectedCoupons];
    newSelectedCoupons[index] = null;
    setSelectedCoupons(newSelectedCoupons);
  };

  const startIndex = pageIndex * couponsPerPage;
  const pageCoupons = selectedCoupons.slice(startIndex, startIndex + couponsPerPage);

  return (
    <div className={`print-a4 ${!selectedBooklet ? 'no-booklet-selected' : ''}`}>
      <div className="print-header">
        <h2>{selectedBooklet?.title || 'Häfte'}</h2>
        <p className='m-0'>{selectedBooklet?.subtitle || ''}</p>
      </div>
      <div className="print-a4-inner">
        <div className="print-inner-header">
          <div className="print-inner-header-left">
            <div className="header-content">
              <h5>Bli en lokal hjälte <span>- Ät shoppa & upplev lokalt!</span></h5>
              <ul className="benefits-list">
                <li>
                  <span className="checkbox">
                    <MdCheck />
                  </span>
                  <span>Rabatter på mat, shopping och upplevelser.</span>
                </li>
                <li>
                  <span className="checkbox">
                    <MdCheck />
                  </span>
                  <span>Bidra till ett rikare föreningsliv.</span>
                </li>
                <li>
                  <span className="checkbox">
                    <MdCheck />
                  </span>
                  <span>Hjälp lokala butiker och företag att växa.</span>
                </li>
              </ul>
              <h5>Köp häftet, gör skillnad och få något tillbaka!</h5>
            </div>
          </div>
          <div className="print-inner-header-right">
            {selectedBooklet && selectedBooklet.colorLeft && (
              <PriceContainer
                price={selectedBooklet.price || 0}
                color={bookletColor}
              />
            )}
            <div className="qr-container">
              <div className="qr-code">
                {/* QR code will be added manually later */}
              </div>
              <div className="qr-code-text">
                <p>Häftet är fyllt med<br />ännu fler erbjudanden!<br />Se och köp här</p>
                <img src={ArrowDown} alt='arrow-down' className='arrow-down' />
              </div>
            </div>
            {selectedBooklet?.imageOfBookletInAppURL ? (
              <div className="shop-share-image-container">
                <img
                  src={`${REACT_APP_IMAGE_BASE_URL}${selectedBooklet.imageOfBookletInAppURL}`}
                  alt="shopShareImageURL"
                  className="shop-share-image"
                />
              </div>
            ) : (
              <div className="shop-share-image-container" style={{ border: '1px solid #ccc' }} />
            )}
          </div>
        </div>
        <div className="coupons-list-header">
          <h5>Ett urval av vad häftet har att erbjuda</h5>
        </div>
        <div className="company-coupons-list">
          <CouponItems
            selectedCoupons={pageCoupons}
            onCouponSelect={handlePlaceholderClick}
            onCouponRemove={handleCouponRemove}
            bookletColor={bookletColor}
            companyCategories={companyCategories}
            startIndex={startIndex}
            selectedBooklet={selectedBooklet}
          />
        </div>
        <div className="company-list-header">
          <h5>Laddat med erbjudanden från kända varumärken och butiker</h5>
          {selectedBooklet && (
            <button
              className="edit-logos-btn"
              onClick={openLogoManager}
              title="Hantera logotyper"
            >
              <small>Ändra</small>
              <FiEdit size={13} />
            </button>
          )}
        </div>
        <div className="company-logos-list">
          {visibleCompanies.map((company) => (
            company?.logoURL && (
              <div className="company-logo-item" key={company._id}>
                <img
                  src={(REACT_APP_IMAGE_BASE_URL || '') + company.logoURL}
                  alt={company.name}
                  className="company-logo"
                />
              </div>
            )
          ))}
        </div>
      </div>
      <PrintFooter />
    </div>
  )
}

export default PrintPage
